module.exports = __webpack_public_path__ + "static/img/mercedes-bg2-1x.6a50416.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mercedes-bg2-1x.png
// module id = zkgR
// module chunks = 0